import { render, staticRenderFns } from "./OrderModel.vue?vue&type=template&id=bd0fea34&"
import script from "./OrderModel.vue?vue&type=script&lang=js&"
export * from "./OrderModel.vue?vue&type=script&lang=js&"
import style0 from "./OrderModel.vue?vue&type=style&index=0&id=bd0fea34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports